<template>
	<div class="wrapper">
		<div class="loginCon">
			<div class="userHeader">
				<i class="back" @click="back"></i>
				<router-link :to="{ name:'registerPage' }" class="loginLink">注册</router-link>
			</div>
			<div class="loginDiv1" v-show="num==1">
				<img src="../../assets/images/user/logo.png" alt="" class="logo" />
				<p class="userIn1 userIn2" style="box-shadow: 0px 50px 0px rgba(77, 75, 75, 0.2);">
					<input type="text" placeholder="账户名" autocomplete="off" v-model="account" maxlength="20" />
					<img src="../../assets/images/user/user.png" alt="" />
				</p>
				<p class="userIn1 userIn2" style="box-shadow: 0px 50px 0px rgba(77, 75, 75, 0.2);">
					<input type="password" placeholder="密码" autocomplete="off" v-model="passNum" maxlength="20" />
					<img src="../../assets/images/user/password.png" alt="" class="passwordImg" />
				</p>
				<div>
					<p class="userIn1 userIn2" style="margin-bottom: 0; margin-right: 0; width: 60%; float: left;box-shadow: 0px 50px 0px rgba(77, 75, 75, 0.2);">
						<input type="text" placeholder="图形验证码" maxlength="4" style="width: 100%;" v-model="code" />
					</p>
					<canvas id="canvas" class="codeImg" @click="imgCode"></canvas>
				</div>
				
				<button class="userBtn1 userBtn2" @click="userLogin">登&nbsp;录</button>
				<p class="otherLogin">
					<span @click="toQuick">手机快捷登录</span>
					<span><a href="/findPwd" style="color: #BDCFEC;">忘记密码</a></span>
				</p>
			</div>
			<div class="loginDiv1" v-show="num==2">
				<img src="../../assets/images/user/logo.png" alt="" class="logo" />
				<p class="userIn1 userIn2" style="box-shadow: 0px 50px 0px rgba(77, 75, 75, 0.2)">
					<input type="number" placeholder="手机号" v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)"
	                 onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" autocomplete="off" />
					<img src="../../assets/images/user/phone.png" alt="" />
				</p>
				<p class="userIn1 userIn2" style="margin-bottom: 0;box-shadow: 0px 50px 0px rgba(77, 75, 75, 0.2);">
					<input type="text" placeholder="验证码" style="width: 60%;" maxlength="6" v-model="dxCodeNum" onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" />
					<button class="getCode" @click="getcodeFuc" id="getCode">{{getCodeNum}}</button>
				</p>
				<button class="userBtn1 userBtn2" @click="quickLogin">登&nbsp;录</button>
				<p class="otherLogin" @click="toPass">账户密码登录<i></i></p>
			</div>
		</div>
		
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
	import {VidateUtil} from '../../assets/js/validate.js' 
	import {sendSms,phoneSeconds} from '../../assets/js/smsUtil.js'
	import {Decrypt,Encrypt} from '../../assets/js/aes/cryptoUtil.js'
	import { Toast } from 'vant'

	export default {
		name: 'loginPage',
		props: {
        
		},
		data(){
		  return {
		    num:2,
			account:'',//账户名
			phone:'',//手机号
			passNum:'',//密码
			code:'', //用户填的图形验证码
			picCode:'', //获取的验证码
			getCodeNum:'获取验证码',//获取短信验证码
			dxCodeNum:'',//用户填的短信验证码
		  }
		},
		components: {
			VidateUtil,
			sendSms,
			phoneSeconds,
		},
		methods:{
			getUserInfo(){
				this.axios({
					method: 'POST',
					url:'/user/getUserName',
				}).then((res)=>{
					if(res.data.obj != null && res.data.obj != ''){
						// 用户已登录，返回首页
						this.$router.push({name:'homePage'});
					}else{
						
					}
				}).catch((err)=>{
					
				})
			},
			back(){
				this.$router.go(-1);
			},
			toQuick(){
			  	this.num=2;
			  	// 置空
			  	this.phone='';
			  	this.dxCodeNum='';
			},
			toPass(){
				this.num=1;
				// 置空
				this.account='';
				this.passNum='';
				this.code='';
			},
			//获取短信验证码
			getcodeFuc(){
				//判断输入的手机号是否合法
			   	if(this.phone == '' || this.phone == null) {
					this.$message.error({message: '手机号码不能为空'});
					return;
				} else if(!/^1[3456789]\d{9}$/.test(this.phone)) {
					this.$message.error({message: '手机号格式有误'});
					return;
			   	} 
				let mobile=Encrypt(this.phone);
				let _this=this;
				sendSms(7,mobile,function(data){//7：登录验证码
					if(data.code == 1000){
						//短信发送成功，弹出提示框
						_this.$toast("已发送验证码到您的手机，请注意查收");
						phoneSeconds(); //倒计时
					}else{
						_this.$message.error({message: data.message});
					}
				},(errorback)=>{
					//回调错误信息
					_this.$message.error({message: errorback});
				});
			},
			//获取图形验证码
			imgCode(){
				this.axios({
				    method: 'POST',
				    url:'/sendCode',
				}).then((res)=>{
					let data = res.data;
					VidateUtil.drawPic(data);
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			quickLogin(){
				if (this.phone == "" || this.phone == null) {
				       this.$message.error({message: '手机号不能为空'});
				       return;
				}else if(!/^1[3456789]\d{9}$/.test(this.phone)) {
						this.$message.error({message: '手机号输入不正确'});
						return;
				}else if (this.dxCodeNum == "" || this.dxCodeNum == null) {
				        this.$message.error({message: '验证码不能为空'});
				        return;
				}else if (this.dxCodeNum.length != 6) {
				        this.$message.error({message: '验证码输入不正确'});
				        return;
				 }else{
					 this.axios({
				     method:'post',
				     url:'/user/doLogin',
				     params:{
				        account: this.phone,
						num:this.num,
				        data: this.dxCodeNum,
						picCode:this.code,
				     }
				   }).then(res=>{
				     	let data = res.data.code;
						if(data == 1000){
							let targetUrl=this.$route.query.targetUrl;
							if(typeof(targetUrl) == "undefined"){
								//登录成功，跳转到首页
								this.$router.push({ name: 'homePage' });
							}else{
								if (targetUrl != null && targetUrl != '') {
									window.location.href=targetUrl;
								} else {
									//登录成功，跳转到首页
									this.$router.push({ name: 'homePage' });
								}
							}
						}else if(data==1102){
							this.$message.error({message: '手机号不得为空'});
						}else{
							this.$message.error({message: res.data.message});
						}
				   }).catch(err=>{
						this.$message.error({message: '网络异常，请稍后重试'});
				   });
				 }
			},
			userLogin() {
			   if (this.account.length < 2 || this.account.length > 20) {
			         this.$message.error({message: '账户名长度为2-20位'});
			          return;
			    }else if (!VidateUtil.checkUserName(this.account)) {
			          this.$message.error({message: '账户名不能有特殊字符'});
			          return;
			    }else if (this.passNum == "" || this.passNum == null) {
			          this.$message.error({message: '密码不能为空'});
			          return;
			     }else if (this.passNum.length < 8 || this.passNum.length > 20) {
			          this.$message.error({message: '密码长度为8-20位'});
			          return;
			     }else if(!VidateUtil.checkPassword(this.passNum)){
			   		  this.$message.error({message: '密码格式不正确'});
			   		  return;
			    }else if(this.code == "" || this.code == null) {
			          this.$message.error({message: '验证码不能为空'});
			          return;
			     }else if (this.code.length != 4){
			          this.$message.error({message: '验证码输入不正确'});
			          return;
			     }else{
					this.axios({
			        method:'post',
			        url:'/user/doLogin',
			        params:{
			          account: this.account,
					  num:this.num,
			          data: this.passNum,
					  picCode:this.code,
			        }
			      }).then(res=>{
			        let data = res.data.code;
					if(data==1000){
						let targetUrl=this.$route.query.targetUrl;
						if(typeof(targetUrl) == "undefined"){
							//登录成功，跳转到首页
							this.$router.push({name: 'homePage'});
						}else{
							if (targetUrl != null && targetUrl != '') {
								window.location.href=targetUrl;
							} else {
								//登录成功，跳转到首页
								this.$router.push({name: 'homePage'});
							}
						}
						
					}else if(data==1100){
						this.imgCode();
						this.$message.error({message: '账户名不得为空'});
					}else if(data==1101){
						this.imgCode();
						this.$message.error({message: '登录失败，请稍后再试'});
					}else if(data==1102){
						this.imgCode();
						this.$message.error({message: '登录密码不得为空'});
					}else if(data==1103){
						this.imgCode();
						this.$message.error({message: '登录密码格式有误,请重新输入'});
					}else if(data==1104){
						this.imgCode();
						this.code='';
						this.$message.error({message: '账户名与登录密码不匹配'});
					}else if(data==1105){
						this.imgCode();
						this.code='';
						this.$message.error({message: '账户名与登录密码不匹配'});
					}else if(data==3101){
						this.imgCode();
						this.code='';
						this.$message.error({message: res.data.message});
					}else{
						this.code='';
						this.imgCode();
						this.$message.error({message: res.data.message});
					}
			      }).catch(err=>{
			      	 	this.imgCode();
			      	 	this.code='';
					 	this.$message.error({message: '网络异常，请稍后重试'});
			      });
			    }
			}
		},
		created() {
			this.imgCode();
			this.getUserInfo();
		}
	}
</script>